export default class UnreachableException {
    error;
    constructor(value) {
        this.error = new Error(`unreachable case: ${JSON.stringify(value)}`);
    }
}
